export const defaultPdfs = [
  {
    id: 1,
    name: { it: "Schede tecniche", en: "Techical data sheets" },
    image: 1,
  },
  {
    id: 2,
    name: { it: "Schemi di montaggio", en: "Assembly instructions" },
    image: 2,
  },
];
